import {
  CopyButton,
  SmallButton,
} from 'components/common-form/builder/form/node/field/BatchMultipleUnderlyingsField/MultipleUnderlyingsComponent/Buttons';
import { EditingUnderlyingsMessage } from 'components/common-form/builder/form/node/field/BatchMultipleUnderlyingsField/MultipleUnderlyingsComponent/EditingUnderlyingMessage';
import { UnderlyingResults } from 'components/common-form/builder/form/node/field/BatchMultipleUnderlyingsField/MultipleUnderlyingsComponent/model';
import { WithUnderlyingInfoTooltip } from 'components/shared/UnderlyingInfo/WithUnderlyingInfoTooltip';
import { UnderlyingTag } from 'components/underlying-tag';
import styled from 'styled-components';

import { displayUnderlyingCode } from '../../utils';

const StyledTagsContainer = styled.div<{ $hasTag: boolean }>`
  display: flex;
  flex-wrap: wrap;
  flex: auto;
  padding: 6px 10px 6px;
  padding-bottom: ${({ $hasTag }) => ($hasTag ? '3px' : '6px')};
`;

export function ValidTags({
  tags,
  invalidTags,
  isDisabled = false,
  onRemove,
  defaultUnderlyingCodeType,
  isEditing,
  selectedUnderlyingsIds,
  onValidTagRemovedAll,
}: UnderlyingResults) {
  return (
    <StyledTagsContainer $hasTag={tags.length > 0} className="pe-0 w-50 text-truncate gap-2">
      {invalidTags.map(tag => (
        <UnderlyingTag label={tag.value} key={tag.value} value={tag.rawValue} />
      ))}
      {tags.map(
        ({ rawValue }) =>
          !!rawValue && (
            <WithUnderlyingInfoTooltip key={rawValue.id} underlying={rawValue} className="d-flex gap-1">
              <UnderlyingTag
                dataE2e="multiple-underlyings-badge"
                dismissDataE2e={`multiple-underlyings-remove-${rawValue.id}-button`}
                label={displayUnderlyingCode(defaultUnderlyingCodeType, rawValue)}
                key={rawValue.id}
                value={rawValue}
                onRemove={() => onRemove(rawValue.id)}
              />
            </WithUnderlyingInfoTooltip>
          ),
      )}

      <div className="align-self-end flex-grow-1 d-flex justify-content-end py-1">
        {isEditing ? (
          <EditingUnderlyingsMessage />
        ) : (
          <>
            <CopyButton
              className="btn-flat-secondary me-1"
              isDisabled={isDisabled}
              selectedUnderlyingsIds={selectedUnderlyingsIds}
              tooltipKey="form.Underlyings.copyTooltip"
            />
            <SmallButton
              className="btn-flat-secondary me-1"
              iconName="delete_outline"
              isDisabled={isDisabled}
              onClick={onValidTagRemovedAll}
              tooltipKey="form.Underlyings.deleteAllTooltip"
              e2e="multiple-underlyings-remove-all-button"
            />
          </>
        )}
      </div>
    </StyledTagsContainer>
  );
}
